// formulas
import React from 'react';
import { useLocation } from 'react-router-dom';

// Parse in multiple items to avoid refresh at all location changes
const RouteGateway = ({ regex, children }) => {
	const { pathname } = useLocation();

	if (Array.isArray(regex)) {
		for (let i = 0; i < regex.length; i++) {
			if (regex[i].test(pathname)) {
				return children;
			}
		}
	} else if (regex.test(pathname)) {
		return children;
	}
	return null;
};

export default React.memo(RouteGateway);